module.exports = __webpack_public_path__ + "img/arrow_down.a3ed157c.svg";